import { Center, SystemStyleObject } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { ArrowRightIcon } from '../icons';

export function FormSummaryIcon({
  icon,
  styles,
  rotateMobile,
}: {
  icon?: ReactNode;
  styles?: {
    container?: SystemStyleObject;
    icon?: SystemStyleObject;
  };
  rotateMobile?: boolean;
}) {
  return (
    <Center
      boxSize={10}
      borderRadius="50%"
      bg="backgroundCardsTransparentSecondary"
      transform={rotateMobile ? ['rotateZ(90deg)', 'none'] : 'none'}
      {...styles?.container}
    >
      {icon || <ArrowRightIcon {...styles?.icon} />}
    </Center>
  );
}

export function FormSummaryArrowDownIcon() {
  return (
    <FormSummaryIcon
      styles={{ container: { mx: 'auto' }, icon: { transform: 'rotateZ(90deg)' } }}
    />
  );
}
